import React, { createContext, useEffect, useState } from 'react';
import MainContentLayout from '../../../components/Layout/MainContentLayout';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { useParams,useNavigate } from 'react-router-dom';
import { Button,Tabs,Tab, Step, Stepper, StepLabel, Paper, Modal, Box, Typography } from '@mui/material';
import { ArrowBack, Close } from '@mui/icons-material';
import { BookingService } from '../Service';
import InitiateBooking from './InitiateBooking';
import BookingResponse from './BookingResponse';
import { CustomerService } from '../../Customer/Service';
import Swal from 'sweetalert2';
import { CrudServices } from '../../MasterService/CrudServices';
import { set } from 'zod';
import BookingSchedule from './BookingSchedule';
import BookingReview from './BookingReview';
import Payment from './Payment';

const BookingDataContext = createContext();
const StepperDataContext = createContext();
const DataContext = createContext();

// this helper function properly compares two service arrays, checking for: Array length changes,Service ID changes,Quantity changes,Service time changes

const areServicesEqual = (prev, curr) => {
    if (prev.length !== curr.length) return false;
    
    return prev.every((prevService, index) => {
      const currService = curr[index];
      return prevService.id === currService.id && 
             prevService.quantity === currService.quantity &&
             prevService.serviceTime === currService.serviceTime;
    });
};

const UpdateBooking = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const initialData ={
        customer:'',
        selected_address:'',
        address:'',
        apartmentRoadArea:'',
        houseFlatBlockNo:'',
        landmark:'',
        city:'',
        latitude:'',
        longitude:'',
        pincode:'',
        state:'',
        categoryId: '',      
        subCategoryId:'',            
        serviceExpert: '',            
        services:[],     
    }
    const [bookingInitiationData,setBookingInitiationData] = useState(initialData);
    const [dateTimeSlot,setDateTimeSlot] = useState({
        serviceDate:'',
        timeSlot:'',
    })
    const [expertDetails,setExpertDetails] = useState({});
    const [chargeDetails, setChargeDetails] = useState({
        additionalCharge:'0',
        vistingCharge:'0',
        cancellationChargeInPercent:'0',
        timeLimitForCancellation:'0',
        isRefundable:false,
        refundableAmount:'0',
        refundableDuration:'0',
        waiveVisitCharge:'0',
    });
    const [walletdetails,setWalletDetails] = useState({
        coinValue:0,
    })

    const [finalBookingCalculation,setFinalBookingCalculation] = useState({
        subTotal:0,
        visitingCharge:chargeDetails.vistingCharge,
        total:0,
        coinValue:0,
    });

    const [paymentDetails,setPaymentDetails] = useState({
        paymentMode:'',
    })

    const [activeStep, setActiveStep] = useState(0);
    const [completed, setCompleted] = useState({});
    const steps = ['Initiate Booking', 'Schedule', 'Review', 'Payment'];

    const totalSteps = () => {
        return steps.length;
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const handleNext = () => {
        const newActiveStep =
        isLastStep() && !allStepsCompleted()
            ? // It's the last step, but not all steps have been completed,
            // find the first step that has been completed
            steps.findIndex((step, i) => !(i in completed))
            : activeStep + 1;
        setActiveStep(newActiveStep);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
    const handleStep = (step) => () => {
        setActiveStep(step);
    };

    const handleComplete = () => {
        setCompleted({
        ...completed,
        [activeStep]: true,
        });
        handleNext();
    };
    const setStepInComplete = () => {
        setCompleted({
        ...completed,
        [activeStep]: false,
        });
        // handleNext();
    };
    const handleReset = () => {
        setBookingInitiationData(initialData);
        setDateTimeSlot({
            serviceDate:'',
            timeSlot:'',
        });
        setExpertDetails({});
        setChargeDetails({
            additionalCharge:'0',
            vistingCharge:'0',
            cancellationChargeInPercent:'0',
            timeLimitForCancellation:'0',
            isRefundable:false,
            refundableAmount:'0',
            refundableDuration:'0',
            waiveVisitCharge:'0',
        });
        setActiveStep(0);
        setCompleted({});
    }

     // Data fetching state
     const [bookingResponseDetails, setBookingResponseDetails] = useState({});
     const [previousServices, setPreviousServices] = useState([]);
     const [isLoadingCustomerList, setIsLoadingCustomerList] = useState(false);
     const [customerList, setCustomerList] = useState([]);
     const [addressList, setAddressList] = useState([]);
     const [categoryList, setCategoryList] = useState([]);
     const [subCategoryList, setSubCategoryList] = useState([]);
     const [expertList, setExpertList] = useState([]);
     const [serviceList, setServiceList] = useState([]);
     const [timeSlotList, setTimeSlotList] = useState([]);
     const [isLoadingBookingData, setIsLoadingBookingData] = useState(false);
     const [fetchedBookingData, setFetchedBookingData] = useState({});
     const [serviceData, setServiceData] = useState(null);
     

    // fetch customer list
    const fetchCustomerlist = async()=>{
        setIsLoadingCustomerList(true)
        try {
            const customerListResponse = await CustomerService.unsortedCustomerList();
            // console.log("customer list Response:",customerListResponse);
            if(customerListResponse.success===1){
            setCustomerList(customerListResponse.data)
            }
        } catch (error) {
            
        }finally{
            setIsLoadingCustomerList(false);
        }
    }
    useEffect(()=>{  
    // console.log("customer list data useeffect is called");
        // if(id==0){
            fetchCustomerlist();
        // }
    },[])

    
    useEffect(()=>{
        if(id>0){
            const fetchBookingData = async()=>{
                setIsLoadingBookingData(true);
                try {
                    const bookingDataResponse = await BookingService.bookingDetailById(id);
                    console.log("booking data response:",bookingDataResponse);
                    if(bookingDataResponse.status == 'success'){
                        setFetchedBookingData(bookingDataResponse.data);
                        // fetchCustomerlist();
                    }
                }
                catch (error) {
                    console.log("error in fetchBookingData:",error);
                }
                finally{
                    setIsLoadingBookingData(false);
                }
            }
            fetchBookingData();
        }
    },[id])

    // Fetch service data for a specific service ID
    const fetchServiceData = async (serviceId) => {
        try {
            const serviceDataResponse = await CrudServices.fetchServiceData(serviceId);
            // console.log("serviceDataResponse:",serviceDataResponse);
            if (serviceDataResponse.success == '1') {
                console.log("serviceDataResponse:",serviceDataResponse);
                const rowData = serviceDataResponse.data;
                const formattedData = {
                    id: rowData?.id,
                    categoryId: rowData?.ServiceCategoryRels[0]?.ServiceCategory.parentId,
                    subCategoryId: rowData?.ServiceCategoryRels[0]?.serviceCategoryId,
                    parentServiceId: rowData.parentServiceId,
                };
                setServiceData(formattedData);
                setBookingInitiationData((prevData) => ({
                    ...prevData,
                    categoryId: formattedData.categoryId,
                    subCategoryId: formattedData.subCategoryId,
                }));
            }
        } catch (error) {
            console.error("Error fetching service data:", error);
        }
    };

    // Process fetched booking items to get service data
    useEffect(() => {
        if (fetchedBookingData.id && !serviceData) {
            console.log("fetchedBookingData:",fetchedBookingData);
            const items = fetchedBookingData?.bookingItems || [];
            if (items.length > 0 && items[0]?.providerServices?.childService?.id) {
                fetchServiceData(items[0]?.providerServices?.childService?.id);
            }
            setBookingInitiationData((prevData) => ({
                ...prevData,
                serviceExpert:fetchedBookingData?.provider?.id
            }));
        }

    }, [fetchedBookingData]);


    useEffect(()=>{
        if (fetchedBookingData?.customerId && !bookingInitiationData.customer && customerList.length > 0) {
            const customer = customerList.find((customer) => customer.id === fetchedBookingData.customerId);
            if (customer) {
                setBookingInitiationData((prevData) => ({
                    ...prevData,
                    customer: customer,
                }));
            }
            
        }
    },[customerList,fetchedBookingData])
    useEffect(()=>{
        if(fetchedBookingData.id && ! bookingInitiationData.selected_address && addressList.length > 0){
            console.log("addressList:",addressList);
            const address = addressList.find((address) => address.address === fetchedBookingData.add_address);
            console.log("address:",address);
            if (address) {
                setBookingInitiationData((prevData) => ({
                    ...prevData,
                    selected_address: address,
                    address:address?.address,
                    apartmentRoadArea:address?.apartmentRoadArea,
                    houseFlatBlockNo:address?.houseFlatBlockNo,
                    landmark:address?.landmark,
                    city:address?.city,
                    latitude:address?.latitude,
                    longitude:address?.longitude,
                    pincode:address?.pincode,
                    state:address?.state,

                }));
            }
        }
    },[addressList,fetchedBookingData])
    
    useEffect(()=>{
        if(fetchedBookingData?.bookingItems){
        if(fetchedBookingData?.bookingItems.length> 0 && serviceList.length > 0){
            console.log("fetchedBookingData.bookingItems:",fetchedBookingData.bookingItems);
            const mappedServices = fetchedBookingData.bookingItems.map(item => {
                const service = serviceList.find(
                    s => s.id === item.providerServiceId
                );
                
                if (service) {
                    return {
                        ...service,
                        quantity: item.quantity || 1
                    };
                }
                return null;
            }).filter(Boolean);
            console.log("mappedServices:",mappedServices);
            if (mappedServices.length > 0) {
                setBookingInitiationData(prev => ({
                    ...prev,
                    services: mappedServices
                }));
                if (dateTimeSlot.serviceDate && dateTimeSlot.timeSlot) {
                    setCompleted({ 0: true, 1: true });
                    // activeStep < 2 && setActiveStep(2);
                }else{
                    setCompleted({ 0: true });
                    // activeStep < 1 && setActiveStep(1);
                }
            }
        }
    }
    },[serviceList])

    useEffect(() => {
        if (bookingInitiationData.services.length > 0) {

            // console.log('previousServices:',previousServices);
            // console.log('bookingData.services:',bookingData.services);
            // Only proceed if there are actual changes in services
        //   console.log('is there any changes in services',!areServicesEqual(previousServices, bookingData.services)) ;
            if (!areServicesEqual(previousServices, bookingInitiationData.services)) {
            setDateTimeSlot(prev => ({
                timeSlot: '',
                serviceDate: ''
            }));
            
            // Reset completion status - only step 0 remains complete
            setCompleted({ 0: true});
    
            // Optionally, move back to step 1 if user is beyond it
            if (activeStep > 1) {
                setActiveStep(1);
            }
            // Update previous services
            setPreviousServices(bookingInitiationData.services);
            }
        } 
    }, [bookingInitiationData.services]);


    // Context values
    const bookingDataContextValue = {
        initialData,
        bookingInitiationData,
        setBookingInitiationData,
        dateTimeSlot,
        setDateTimeSlot,
        expertDetails,
        setExpertDetails,
        chargeDetails,
        setChargeDetails,
        walletdetails,
        setWalletDetails,
        finalBookingCalculation,
        setFinalBookingCalculation,
        paymentDetails,
        setPaymentDetails,
    };

    const stepperContextValue = {
        activeStep,
        setActiveStep,
        completed,
        setCompleted,
        handleNext,
        handleBack,
        handleStep,
        handleComplete,
        setStepInComplete,
        handleReset,
        previousServices,
        setPreviousServices,
        bookingResponseDetails,
        setBookingResponseDetails,
    };

    const dataContextValue = {
        isLoadingCustomerList,
        customerList,
        addressList,
        setAddressList,
        categoryList,
        setCategoryList,
        subCategoryList,
        setSubCategoryList,
        expertList,
        setExpertList,
        serviceList,
        setServiceList,
        timeSlotList,
        setTimeSlotList,
    };

    // Determine current step component
    const renderStepContent = () => {
        switch (activeStep) {
            case 0:
                return <InitiateBooking />;
            case 1:
                return <BookingSchedule />;
            case 2:
                return <BookingReview />;
            case 3:
                return <Payment />;
            default:
                return null;
        }
    };
    
  return (
    <BookingDataContext.Provider value={bookingDataContextValue}>
        <>
            <PageHeaderLayout headerTitle={id>0 ? `Edit Booking Detail's`:`Create New Booking`}>
                <Button size='small' variant='contained' onClick={() => navigate(-1)} endIcon={<ArrowBack sx={{fontSize:'.85rem!important'}}/>} sx={{height:'fit-content',fontSize:'x-small',p:'.5% 1.25%'}}>
                    Back
                </Button>
            </PageHeaderLayout>
            <StepperDataContext.Provider value={stepperContextValue}>
                <Paper sx={{ overflow: "auto",padding:{xs:'2%',md:'1% 0% 1% 0%'},mb:'.25%' }}>
                    <Stepper nonLinear activeStep={activeStep} alternativeLabel>
                        {steps.map((label, index) => {
                            // Find the highest completed step index
                            const lastCompletedStep = Math.max(-1, ...Object.keys(completed).map(Number));
                            // Step is clickable if it's completed or if it's the next step after the last completed one
                            const isClickable = completed[index] || index === lastCompletedStep + 1;
                            
                            return (
                                <Step key={label} completed={completed[index]}>
                                    <StepLabel 
                                        onClick={() => isClickable ? handleStep(index)() : null}
                                        sx={{
                                            cursor:  'pointer',
                                            '&:hover': {
                                                opacity: isClickable ? 0.8 : 1,
                                            }
                                        }}
                                    >
                                        {label}
                                    </StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </Paper>
                <Paper sx={{pt:'1%'}}>
                    <DataContext.Provider value={dataContextValue}>
                        {allStepsCompleted() ? (
                            <>
                                <BookingResponse/>
                            </>
                            ) : (
                                <>
                                    {renderStepContent()}
                                </>
                            )
                        }
                    </DataContext.Provider>
                </Paper>
            </StepperDataContext.Provider>
        </>
    </BookingDataContext.Provider>
  );
}

export default UpdateBooking;
export {BookingDataContext,StepperDataContext,DataContext}